import React, { FunctionComponent, ReactNode } from 'react'
import style from './style.module.css'

export const Container: FunctionComponent<ReactNode> = ({ children }) => {
  return <div className={style.container}>{children}</div>
}

export default Container
